import React from 'react';

/**
 * ClinicalCard - Standardized card component for displaying clinical information
 * Provides consistent styling and layout for all cockpit information panels
 */
interface ClinicalCardProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerAction?: React.ReactNode;
  variant?: 'default' | 'compact' | 'elevated';
  size?: 'sm' | 'md' | 'lg';
}

const ClinicalCard: React.FC<ClinicalCardProps> = ({
  title,
  icon,
  children,
  className = '',
  headerAction,
  variant = 'default',
  size = 'md'
}) => {
  const baseClasses = 'bg-white rounded-lg border border-gray-200';
  
  const variantClasses = {
    default: 'shadow-sm',
    compact: 'shadow-xs',
    elevated: 'shadow-md'
  };

  const sizeClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const cardClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <div className={cardClasses}>
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          {icon && (
            <div className="mr-3 text-gray-400">
              {icon}
            </div>
          )}
          <h3 className="text-lg font-medium text-gray-900">
            {title}
          </h3>
        </div>
        {headerAction && (
          <div className="flex-shrink-0">
            {headerAction}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="clinical-card-content">
        {children}
      </div>
    </div>
  );
};

export default ClinicalCard;